"use strict";
/// <reference types="./schema" />
/* eslint-disable @typescript-eslint/ban-ts-comment */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isToolsProduct = exports.isGenericProduct = exports.isTransportProduct = exports.isMachineryPart = exports.isMachineryEquipment = exports.isMachineryProduct = exports.isValidProduct = exports.isPrimitive = exports.brandTypes = exports.weightMeasurementUnits = exports.lengthMeasurementUnits = exports.teamRoles = exports.deliveryMethodTypes = exports.exchangeMethodTypes = exports.quotationStatusTypes = exports.requestStatusTypes = exports.machineryManufacturerTypes = exports.machineryConditionsTypes = exports.productVariantTypes = exports.tuple = void 0;
// Type helpers
const tuple = (...args) => args;
exports.tuple = tuple;
// Tuples
exports.productVariantTypes = exports.tuple('machineryProduct', 'transportProduct', 'genericProduct', 'toolsProduct');
exports.machineryConditionsTypes = exports.tuple('new', 'used', 'reconditioned');
exports.machineryManufacturerTypes = exports.tuple('oem', 'aftermarket');
exports.requestStatusTypes = exports.tuple('active', 'closed');
exports.quotationStatusTypes = exports.tuple('pending', 'cancelled', 'accepted');
exports.exchangeMethodTypes = exports.tuple('collect', 'delivery');
/** @deprecated in favor of exchangeMethod */
exports.deliveryMethodTypes = exports.tuple('collect', 'delivery', 'all');
exports.teamRoles = exports.tuple('owner', 'administrator', 'manager', 'member');
exports.lengthMeasurementUnits = exports.tuple('millimeter', 'centimeter', 'meter', 'kilometer');
exports.weightMeasurementUnits = exports.tuple('tonne', 'kilogram', 'gram', 'milligram');
exports.brandTypes = exports.tuple('machineryBrand', 'toolsBrand');
// Type Checkers
function isPrimitive(test) {
    return typeof test === 'string' || typeof test === 'number';
}
exports.isPrimitive = isPrimitive;
const resolveTestType = (tested) => {
    if (!tested)
        return '';
    // @ts-ignore - ambiguous type 🦄
    const type = (tested === null || tested === void 0 ? void 0 : tested._type) || tested;
    if (typeof type === 'string')
        return type;
    return '';
};
//  Type Checkers
function isValidProduct(tested) {
    return exports.productVariantTypes.includes(resolveTestType(tested));
}
exports.isValidProduct = isValidProduct;
function isMachineryProduct(tested) {
    return ['machineryProduct'].includes(resolveTestType(tested));
}
exports.isMachineryProduct = isMachineryProduct;
function isMachineryEquipment(tested) {
    return ['machineryEquipment'].includes(resolveTestType(tested));
}
exports.isMachineryEquipment = isMachineryEquipment;
function isMachineryPart(tested) {
    return ['machineryPart'].includes(resolveTestType(tested));
}
exports.isMachineryPart = isMachineryPart;
function isTransportProduct(tested) {
    return ['transportProduct'].includes(resolveTestType(tested));
}
exports.isTransportProduct = isTransportProduct;
function isGenericProduct(tested) {
    return ['genericProduct'].includes(resolveTestType(tested));
}
exports.isGenericProduct = isGenericProduct;
function isToolsProduct(tested) {
    return ['toolsProduct'].includes(resolveTestType(tested));
}
exports.isToolsProduct = isToolsProduct;
//# sourceMappingURL=types.js.map